export const users = [
  {
    id: 1,
    name: "John Doe",
    email: "johndoe@gmail.com",
    phone: "1-770-736-8031 x56442",
    address: "123 Main St, Kahawa Sukari, Kiambu"
  },
  {
    id: 2,
    name: "Jane Doe",
    email: "Janedoe@gmail.com",
    phone: "010-692-6593 x09125",
    address: "456 Oak Avenue, Nairobi, Kenya"
  },
  {
    id: 3,
    name: "Clementine Bauch",
    email: "Clemt@gmail.com",
    phone: "1-463-123-4447",
    address: "789 Pine Street, Mombasa, Kenya"
  },
  {
    id: 4,
    name: "Patricia Lebsack",
    email: "patricia12@gmail.com",
    phone: "493-170-9623 x156",
    address: "321 Elmu Street, Kisumu, Kenya"
  },
  {
    id: 5,
    name: "Christian Bale",
    email: "christiano0@gmail.com",
    phone: "(254)954-1289",
    address: "654 Maple Drive, Eldoret, Kenya"
  }
];